import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaButtonGroup from './VaButtonGroup.vue'

export * from './VaButtonGroup.vue'

export default withConfigTransport(VaButtonGroup)
